import React, { useCallback, useState } from 'react';
import { Token } from 'src/common/api/use-integrations.hook';
import GooglePicker from 'src/integrations/GooglePicker';
import { GoogleDriveIntegrationIcon } from 'src/monet/icons';
import { NeueButtonBase } from '../components/neue-button/base';

interface IntegrationGooglePickerButtonProps {
  token: Token;
  onFileSelected: (embedUrl: string, name: string) => void;
};

export const IntegrationGooglePickerButton: React.FC<IntegrationGooglePickerButtonProps> = ({
  token,
  onFileSelected,
  children,
}) => {
  const onChange = useCallback(
    async (data, google, updateFilePermissionToPublic) => {
      if (data.action !== google.picker.Action.PICKED) return;
      let doc = data[google.picker.Response.DOCUMENTS][0];
      const docId = doc.id;

      const submitFile = () => {
        let embedUrl = doc[google.picker.Document.EMBEDDABLE_URL];
        let name = doc[google.picker.Document.NAME];
        onFileSelected(embedUrl, name);
      };

      try {
        await updateFilePermissionToPublic(docId);
      } catch {
        // Nothing to do
      } finally {
        submitFile();
      }
    },
    [onFileSelected]
  );

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  return (
    <GooglePicker
      accessToken={token.access_token}
      setError={setErrorMessage}
      mimeTypes={null}
      navHidden={true}
      tokenID={token.id}
      onChange={onChange}
      className="flex-1"
    >
      <NeueButtonBase
        className={'py-[9px] px-4 text-neue-journey-fg w-full'}
        baseColor={'rgb(var(--neue-journey-fg-10))'}
        gradientMaxOpacity={0.1}
      >
        <div className="flex flex-1 items-center space-x-2">
          <GoogleDriveIntegrationIcon className="w-5 h-5" />
          <div>Pick from Google Drive</div>
        </div>
      </NeueButtonBase>
    </GooglePicker>
  )
}